module.exports = __webpack_public_path__ + "img/Stars_01.e7e47862.png";